export const datHang = {
  sections: { list: { title: '订货' }, detail: { title: '订单详情' } },
  lineList: {
    title: '订货商品明细',
    tabOrders: '订货',
    tabLines: '商品明细',
    summary: '共 {count} 行商品',
    noData: '暂无数据',
    columns: {
      maDatHang: '订货单号',
      thoiGian: '下单时间',
      trangThai: '状态',
      chiNhanh: '分店',
      nguoiBan: '销售员',
      maKhachHang: '客户编码',
      tenKhachHang: '客户名称',
      maHangHoa: '商品编码',
      tenHangHoa: '商品名称',
      donViTinh: '单位',
      soLuong: '数量',
      soLuongDaXuat: '已出数量',
      tongCanNang: '重量 (kg)',
      tongTheTich: '体积 (m³)',
      donGia: '单价',
      giamGia: '行折扣',
      giaBan: '售价',
      thanhTien: '金额',
      giamGiaChung: '整单折扣',
      thuKhacChung: '其他收费',
      tongCong: '合计',
      ghiChu: '备注',
    },
  },
  titles: { add: '订货' },
  columns: { code: '单号', summary: '信息', status: '状态', ngayTao: '创建时间', ngayCapNhat: '更新时间' },
  filter: { searchPlaceholder: '按单号搜索...' },
  filters: {
    all: '全部',
    fromDate: '开始日期',
    toDate: '结束日期',
    dateRange: '时间范围',
    dateRangePlaceholder: '选择日期范围',
    status: '状态',
    statusSection: '订单状态',
    dateSection: '下单时间',
    salesSection: '销售',
    peopleSection: '用户',
    receiver: '接单人员',
    deliverySection: '配送',
    deliveryPartner: '配送伙伴',
    deliveryArea: '配送区域',
    favoriteSection: '收藏',
    textDetailTitle: '订单筛选',
    khachHangPlaceholder: '搜索客户',
    locChung: '通用筛选',
    maDonHang: '按单号',
    maNhanVien: '员工编码',
    maKhachHang: '客户编码',
    tenKhachHang: '客户名称',
    diaChiNhanHang: '收货地址',
    diaChiGiaoHang: '发货地址',
    sortField: '排序字段',
    sortDir: '排序方向',
    sortThoiGian: '下单时间',
    sortMaDonHang: '订单号',
    sortKhachCanTra: '应付金额',
    sortTongTienHang: '商品总额',
  },
  form: {
    code: '订单号',
    codeAuto: '留空自动生成',
    customer: '客户',
    retailCustomer: '散客',
    congNoHienTai: '当前欠款',
    congNoKhachNo: '客户欠款',
    congNoNoKhach: '欠客户',
    channel: '销售渠道',
    discount: '折扣',
    discountPercent: '折扣 (%)',
    otherIncome: '其他收入',
    note: '备注',
    lines: '明细行',
    danhSachChiTiet: '明细列表',
    addLine: '添加行',
    product: '商品',
    productName: '商品名称',
    productSearch: '搜索编码/名称',
    qty: '数量',
    unitPrice: '单价',
    lineNote: '行备注',
    lineAmount: '金额',
    deliverySection: '配送信息',
    paymentSection: '付款',
    addPayment: '添加付款行',
    removePayment: '删除',
    paymentAmount: '金额',
    tabGeneral: '基本信息',
    tabLines: '商品明细',
    tabDelivery: '配送',
    tabPayment: '付款',
    discountShort: '折扣',
    salePrice: '售价',
    bangGiaDefault: '通用价格表',
    maHang: '商品编号',
  },
  fields: {
    maDatHang: '订单号',
    maKhachHang: '客户编码',
    nhanVienPhuTrach: '客户负责销售',
    soSanPham: '商品种数',
    soLuongSanPham: '商品总数量',
    tongCanNang: '总重量 (kg)',
    tongTheTich: '总体积 (m³)',
    maHoaDon: '发票号',
    nguoiTao: '制单人',
    nguoiTaoHeThong: '系统',
    tenKhachHang: '客户名称',
    khachHang: '客户',
    kenhBan: '销售渠道',
    ngayDatHang: '下单时间',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    bangGia: '价格表',
    trangThai: '状态',
    chiNhanh: '门店',
    hinhThucGiao: '配送方式',
    diaChiLayHang: '取货地址',
    savedAddress: '已保存配送信息',
    savedAddressPlaceholder: '选择配送信息',
    savedAddressEmpty: '尚未保存配送信息',
    nguoiNhan: '收货人',
    dienThoai: '收货人电话',
    diaChi: '配送地址',
    khuVuc: '省/市',
    phuongXa: '坊/社',
    soKien: '件数',
    trongLuong: '重量',
    donViTrongLuong: '重量单位',
    chieuDai: '长',
    chieuRong: '宽',
    chieuCao: '高',
    donViKichThuoc: '尺寸单位',
    dichVu: '配送服务',
    nguoiGiaoDoiTac: '配送员/伙伴',
    doiTacGiaoHang: '配送伙伴',
    thuHoTien: '货到付款',
    soTienCod: 'COD金额',
    phiTraDTGH: '伙伴运费',
    thoiGianGiaoHang: '交货期限',
    ghiChuGiaoHang: '配送备注',
    ghiChuChoBuuta: '快递员备注',
    tongTienHang: '商品总额',
    giamGia: '折扣',
    thuKhac: '其他收入',
    khachCanTra: '应付金额',
    ghiChu: '订单备注',
    maVanDon: '运单号',
    totalAmount: '总金额',
    paymentMethod: '支付方式',
    yeuThich: '收藏',
    actions: '操作',
    nguoiBan: '销售员',
    nguoiNhanDat: '接单人',
    thoiGian: '下单时间',
    kichThuoc: '尺寸',
    thuHoTienShort: '代收货款',
    khachDaTra: '客户已付',
    giamGiaHoaDon: '发票折扣',
    phiShip: '运费',
    chiNhanhXuLy: '处理分店',
    chiNhanhTao: '创建分店',
  },
  actions: {
    copy: '复制',
    favorite: '收藏',
    changeStatus: '更改状态',
    chotThanhHoaDon: '结转为发票',
    datHang: '下单',
    thayDoiDatHang: '更改订单',
    taoHoaDon: '创建发票',
    xuatHoaDon: '生成发票',
    xuatHoaDonMoi: '导出新发票',
    ketThuc: '结束',
    ketThucSelected: '结束（{count}）',
    ketThucMenu: '结束',
    printSelected: '打印（{count}）',
    printMenu: '打印',
    huySelected: '取消（{count}）',
    huyMenu: '取消',
    bulkSelected: '操作（{count}）',
    dongY: '同意',
    xuLyDonHang: '处理订单',
    print: '打印',
    exportFile: '导出文件',
    huyBo: '取消',
  },
  paymentMethod: {
    TIEN_MAT: '现金',
    THE: '卡',
    VI: '钱包',
    CHUYEN_KHOAN: '转账',
    DIEM: '积分',
  },
  status: {
    PHIEU_TAM: '草稿',
    DANG_XU_LY: '处理中',
    DANG_GIAO_HANG: '配送中',
    HOAN_THANH: '已完成',
    KHONG_GIAO_DUOC: '无法配送',
    DA_HUY: '已取消',
  },
  messages: {
    loadError: '加载失败。',
    deleteSuccess: '已删除。',
    createSuccess: '已创建订单。',
    updateSuccess: '已更新订单。',
    needLines: '请至少添加一行商品。',
    needKhachHang: '请选择客户。',
    validateThoiGianGiaoBeforeThoiGian: '交货时间不能早于单据/订单时间。',
    warnStockCost: '库存/成本预警：{detail}',
    noData: '暂无数据。',
    noLines: '暂无明细行。',
    listSummary: '共 {count} 条',
    confirmDelete: '删除订单 {name}？',
    copySuccess: '已复制订单。',
    favoriteSuccess: '已更新收藏。',
    statusSuccess: '已更新订单状态。',
    confirmKetThuc: '结束订单 {name}？状态将更新为已完成。',
    confirmKetThucSelected:
      '结束已选的 {count} 张订单？状态将更新为已完成。已取消/已完成/已结转的单据将跳过。',
    confirmHuy: '取消订单 {name}？状态将更新为已取消。',
    confirmHuySelected:
      '取消已选的 {count} 张订单？状态将更新为已取消。已取消/已完成/已结转的单据将跳过。',
    huySelectedSuccess: '已取消 {ok}/{total} 张订单。',
    huySelectedPartial: '已取消 {ok}/{total} 张订单。{fail} 张失败或无法取消。',
    huySelectedNone: '所选订单中没有可取消的单据。',
    ketThucSelectedSuccess: '已结束 {ok}/{total} 张订单。',
    ketThucSelectedPartial: '已结束 {ok}/{total} 张订单。{fail} 张失败或无法结束。',
    ketThucSelectedNone: '所选订单中没有可结束的单据。',
    chotSuccess: '订单已结转为发票。',
    chotConfirm: '此订单将结转为新的 HD 发票。是否继续？',
    importSuccess: '导入订单成功。',
    importDescription:
      '请选择模板 Excel 文件导入订货单（草稿）。时间为空/销售员为空 → 使用当前时间/当前登录账号。销售渠道默认自提。',
    importWillCreate: '将从所选文件创建 {count} 张订单。',
    importPreviewProgress: '预览 {current}/{total}',
    importPreviewStopped: '已停止预览。',
    importPreviewDone: '预览完成 {done}/{total} 张订单。',
    importPreviewLoading: '正在准备订单 {current}/{total}…',
  },
  aria: {
    columnPicker: '选择显示列',
    toggleStar: '标记收藏',
    selectAllPage: '选择本页全部行',
    selectRow: '选择行',
  },
  detailTabs: {
    chung: '常规',
    generalInfo: '信息',
    chiTietDonHang: '订单明细',
  },
  placeholders: {
    formTitle: '创建/编辑订单',
    formBody: '完整表单将后续补充。',
    ghiChu: '备注...',
    ghiChuGiao: '配送备注...',
    chonDoiTac: '选择合作方...',
  },
  xuatHoaDon: {
    sectionTitle: '生成发票',
    tienDoTitle: '发票进度',
    chiTietTungDong: '逐行进度',
    danhSachHoaDonCon: '子发票列表',
    xuatHoaDonMoi: '生成新发票',
    modalTitle: '创建子发票',
    modalSubtitle: '选择需要开票的行和数量。',
    submit: '生成发票',
    ghiChuHoaDon: '子发票备注',
    ghiChuPlaceholder: '本次开票内部备注',
    needSelect: '请至少为 1 行输入数量。',
    overQty: '数量超过 {ma} 的剩余可开票数量（仅剩 {conLai}）。',
    createSuccess: '已创建子发票 {ma}。',
    noLinesAvailable: '没有可开票的行（全部已开票或订单为空）。',
    noLines: '无明细行。',
    chuaCoHoaDonCon: '尚未生成任何子发票。',
    colConLai: '剩余',
    colXuat: '开票',
    summary: '已开票 {daXuat}/{tong}（剩 {conLai}）',
    soHang: '{daHet}/{tong} 行已全部开票',
    soHoaDonCon: '{count} 张子发票',
    totalSelected: '已选行数',
    totalQty: '总数量',
  },
  pos: {
    addTab: '添加订单标签',
    history: '历史',
    tabTitle: '订单 {n}',
    tabEdit: '编辑 {code}',
    tabClone: '复制 {code}',
    newTabDatHang: '新订货',
    confirmCloseTitle: '关闭此标签？',
    confirmCloseBody: '该标签有未保存的更改。关闭后将丢失。',
  },
  summary: {
    tongTienHangCount: '商品总额（{count}）',
    tongSoLuong: '总数量',
    tongTienHang: '商品总额',
    giamGiaPhieuDat: '订单折扣',
    tongCong: '合计',
    hangSuaChua: '维修商品',
  },
}
